/**
 * Blog index: tag counts from cards, client-side filter, load-more batching.
 * One init per [data-blog-index] root (supports section editor reload).
 */
(function () {
  function initRoot(root) {
    if (root.getAttribute('data-blog-index-initialized') === 'true') {
      return;
    }

    const tagFilterList = root.querySelector('[data-blog-index-tag-list]');
    const resetButton = root.querySelector('[data-blog-index-reset]');
    const postsGrid = root.querySelector('[data-blog-index-grid]');
    const noPostsMessage = root.querySelector('[data-blog-index-empty]');
    const loadMoreBtn = root.querySelector('[data-blog-index-load-more]');
    const loadMoreContainer = root.querySelector('[data-blog-index-load-more-wrap]');
    const filterSection = root.querySelector('[data-blog-index-filter-details]');

    if (!tagFilterList || !resetButton || !postsGrid || !noPostsMessage || !loadMoreBtn || !loadMoreContainer) {
      return;
    }

    const allCards = root.querySelectorAll('[data-blog-index-card]');
    if (allCards.length === 0) {
      root.setAttribute('data-blog-index-initialized', 'true');
      return;
    }

    const initialVisible = parseInt(postsGrid.getAttribute('data-initial-visible'), 10) || 12;
    const loadBatch = parseInt(postsGrid.getAttribute('data-load-batch'), 10) || 12;

    let activeFilter = null;
    let currentlyShowing = initialVisible;

    function readTags(card) {
      const raw = card.getAttribute('data-tags');
      if (!raw) {
        return [];
      }
      try {
        const parsed = JSON.parse(raw);
        if (Array.isArray(parsed)) {
          return parsed.map(String).filter(Boolean);
        }
      } catch (e) {
        /* fall through */
      }
      return raw
        .split(',')
        .map(function (t) {
          return t.trim();
        })
        .filter(Boolean);
    }

    const tagCounts = {};
    allCards.forEach(function (card) {
      readTags(card).forEach(function (trimmedTag) {
        tagCounts[trimmedTag] = (tagCounts[trimmedTag] || 0) + 1;
      });
    });

    const sortedTags = Object.keys(tagCounts).sort(function (a, b) {
      if (tagCounts[b] !== tagCounts[a]) {
        return tagCounts[b] - tagCounts[a];
      }
      return a.localeCompare(b);
    });

    sortedTags.forEach(function (tag) {
      const li = document.createElement('li');
      const a = document.createElement('a');
      a.href = '#';
      a.className = 'custom-section--blog-index__filter-link';
      a.setAttribute('data-tag', tag);

      const tagName = document.createElement('span');
      tagName.textContent = tag;

      const tagCount = document.createElement('span');
      tagCount.className = 'custom-section--blog-index__filter-count';
      tagCount.textContent = String(tagCounts[tag]);

      a.appendChild(tagName);
      a.appendChild(tagCount);
      li.appendChild(a);
      tagFilterList.appendChild(li);
    });

    const filterLinks = tagFilterList.querySelectorAll('.custom-section--blog-index__filter-link');

    if (filterSection && window.matchMedia('(max-width: 900px)').matches) {
      filterSection.removeAttribute('open');
    }

    function updateLoadMoreVisibility() {
      if (activeFilter) {
        loadMoreContainer.classList.add('custom-section--blog-index__load-more-wrap--hidden');
        return;
      }

      const totalPosts = allCards.length;
      if (currentlyShowing >= totalPosts) {
        loadMoreContainer.classList.add('custom-section--blog-index__load-more-wrap--hidden');
      } else {
        loadMoreContainer.classList.remove('custom-section--blog-index__load-more-wrap--hidden');
      }
    }

    function applyLoadMoreState() {
      allCards.forEach(function (card) {
        const index = parseInt(card.getAttribute('data-index'), 10);
        card.classList.remove('custom-section--blog-index__card--hidden');

        if (index > currentlyShowing) {
          card.classList.add('custom-section--blog-index__card--load-more');
        } else {
          card.classList.remove('custom-section--blog-index__card--load-more');
        }
      });
    }

    function filterCards(tag) {
      let visibleCount = 0;

      allCards.forEach(function (card) {
        card.classList.remove('custom-section--blog-index__card--load-more');

        const matches = readTags(card).includes(tag);

        if (matches) {
          card.classList.remove('custom-section--blog-index__card--hidden');
          visibleCount++;
        } else {
          card.classList.add('custom-section--blog-index__card--hidden');
        }
      });

      loadMoreContainer.classList.add('custom-section--blog-index__load-more-wrap--hidden');

      if (visibleCount === 0) {
        noPostsMessage.hidden = false;
      } else {
        noPostsMessage.hidden = true;
      }
    }

    function clearFilter() {
      activeFilter = null;

      filterLinks.forEach(function (l) {
        l.classList.remove('custom-section--blog-index__filter-link--active');
      });

      resetButton.classList.add('custom-section--blog-index__reset--hidden');

      applyLoadMoreState();
      updateLoadMoreVisibility();

      noPostsMessage.hidden = true;
    }

    filterLinks.forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();

        const tag = this.getAttribute('data-tag');
        if (activeFilter === tag) {
          clearFilter();
          return;
        }

        activeFilter = tag;

        filterLinks.forEach(function (l) {
          l.classList.remove('custom-section--blog-index__filter-link--active');
        });
        this.classList.add('custom-section--blog-index__filter-link--active');

        resetButton.classList.remove('custom-section--blog-index__reset--hidden');

        filterCards(tag);
      });
    });

    resetButton.addEventListener('click', function () {
      clearFilter();
    });

    loadMoreBtn.addEventListener('click', function () {
      currentlyShowing += loadBatch;
      applyLoadMoreState();
      updateLoadMoreVisibility();
    });

    updateLoadMoreVisibility();

    root.setAttribute('data-blog-index-initialized', 'true');
  }

  function initAll(scope) {
    const roots = (scope || document).querySelectorAll('[data-blog-index]');
    for (let i = 0; i < roots.length; i++) {
      initRoot(roots[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    const target = event.target;
    if (target && target.nodeType === 1) {
      initAll(target);
    }
  });
})();
